import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ConfigurationModel } from '../../+state/common.models';
import { CommonState } from '../../+state/common.reducer';
import { getConfiguration } from '../../+state/common.selectors';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  configuration$: Observable<ConfigurationModel>;
  constructor(private http: HttpClient, private store: Store<CommonState>) {
    this.configuration$ = this.store.select(getConfiguration);
  }

  isAuthenticated(apiUrl: string) {
    return this.http.get(`${apiUrl}/authentication/is-authenticated`);
  }
}
